<template>
  <div class="fixed">
    <a-space direction="vertical">
      <!-- <a-tooltip placement="leftTop">
        <template slot="title">意见反馈</template>
<a style="color: #fff;" class="button" target="_bank" href="https://support.qq.com/products/351278">
  <a-icon style="color: #fff;" type="message"></a-icon>
</a>
</a-tooltip> -->
      <a-tooltip placement="leftTop">
        <template slot="title">通知列表</template>
        <a style="color: #fff;" class="button" @click="showNotificationModal">
          <a-icon style="color: #fff;" theme="filled" type="sound"></a-icon>
        </a>
      </a-tooltip>
      <a-tooltip placement="leftTop">
        <template slot="title">操作手册</template>
        <a style="color: #fff;" class="button" target="_bank"
          href="https://newhope1982.feishu.cn/docs/doccnFdcEUrsnM6nkj8BYSdNYmf">
          <a-icon style="color: #fff;" type="read"></a-icon>
        </a>
      </a-tooltip>
    </a-space>
    <!-- 通知列表模态框 -->
    <a-modal title="通知列表" :visible="notificationVisible" @cancel="notificationVisible = false" width="800px"
      :footer="null">
      <a-table :columns="notificationColumns" :dataSource="notificationList" :pagination="notificationPagination"
        :loading="notificationLoading" @change="handleNotificationTableChange" rowKey="id">
        <span slot="action" slot-scope="text, record">
          <a-button type="link" :disabled="!record.appPagePath && !record.thirdUrl"
            @click="viewNotificationDetail(record)">
            查看详情
          </a-button>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notificationVisible: false,
      notificationList: [],
      notificationLoading: false,
      notificationColumns: [
        {
          title: '标题',
          dataIndex: 'pushTitle',
          key: 'pushTitle',
          ellipsis: true
        },
        {
          title: '内容',
          dataIndex: 'pushContent',
          key: 'pushContent',
          ellipsis: true
        },
        {
          title: '时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 180
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ],
      notificationPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: total => `共 ${total} 条`
      }
    };
  },
  methods: {
    showNotificationModal() {
      this.notificationVisible = true;
      this.getNotificationList();
    },
    // 获取通知列表
    getNotificationList() {
      this.notificationLoading = true;
      const staffId = window.localStorage.getItem('staffId');
      if (!staffId) {
        this.notificationLoading = false;
        return;
      }

      const params = {
        clientId: '1123598811738675201', // NHF客户端id
        staffId: Number(staffId),
        isPush: 1,
        isFilterExpireDate: 1,
        query: {
          current: this.notificationPagination.current,
          size: this.notificationPagination.pageSize
        }
      };
      this.notificationLoading = true;
      this.$post('/nhf-api-center/msgnotice/pageMsgNoticeVO', params)
        .then(res => {
          const { success, data } = res || {};
          if (success && data) {
            const { records, total } = data;
            this.notificationList = records || [];
            this.notificationPagination.total = total || 0;
          } else {
            this.$message.error('获取通知列表失败');
          }
        })
        .catch(err => {
          console.error('获取通知列表失败', err);
          this.$message.error('获取通知列表失败');
        })
        .finally(() => {
          this.notificationLoading = false;
        });
    },
    // 处理表格分页、排序、筛选变化
    handleNotificationTableChange(pagination) {
      this.notificationPagination.current = pagination.current;
      this.notificationPagination.pageSize = pagination.pageSize;
      this.getNotificationList();
    },
    // 查看通知详情
    viewNotificationDetail(record) {
      // 标记为已读
      this.markAsRead(record.id);

      // 根据appPagePath和thirdUrl决定跳转行为
      if (record.appPagePath) {
        this.$router.push(`${record.appPagePath}?name=${record.appPageName}`);
        this.notificationVisible = false;
        return;
      }

      if (record.thirdUrl && record.thirdUrl.startsWith('http')) {
        window.open(record.thirdUrl);
        this.notificationVisible = false;
      }
    },
    // 标记通知为已读
    markAsRead(noticeId) {
      if (!noticeId) return;

      const staffId = window.localStorage.getItem('staffId');
      if (!staffId) return;

      this.$post('/nhf-api-center/msgnotice/viewMsgNotice', {
        id: noticeId,
        staffId: Number(staffId)
      }).then(res => {
        console.log('标记已读结果:', res);
      }).catch(err => {
        console.error('标记已读失败', err);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fixed {
  position: fixed;
  right: 0;
  bottom: 100px;
  z-index: 100;

  a {
    font-size: 20px;
    background: #1890ff;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 5px 0 0 5px;
  }
}
</style>